export const MAX_MOBILE_WIDTH = 600;
export const MAX_TABLET_WIDTH = 1279;
